function path() {
    return {
      baseURL: 'https://webgis2.nic.in/dbt1API/',
      baseURL1: '/findmybank/',
      baseURL2: 'https://webgis2.nic.in/apivalidate/',
      gisheadername: 'Find My Bank',
      AdminHeadername: "DBT GIS - Web GIS for Financial Inclusion",
      misheadernamemobile: 'GIS for Financial Inclusion',
      misheadername: 'GIS  for Banking Locations ',
      masterlogin:'https://webgis2.nic.in/ummapi/',
      excelapi : 'https://webgis2.nic.in/analysisapi/'
      
      
      
    };
  }
  
  export default path;
  
  